import { FunctionComponent, useState } from 'react'
import { Dialog } from '@headlessui/react'
import styles from './SizeGuideModal.module.css'
import iconLink from '~public/images/icon-link.svg'
import iconClose from '~public/images/icon-close.svg'

const adultSizes = [
  ['XS', '31"-34"'],
  ['S', '34"-37"'],
  ['M', '38"41"'],
  ['L', '42"-45"'],
  ['XL', '46"-49"'],
  ['XXL', '50"-53"'],
  ['XXXL', '54"-57"'],
]

export const SizeGuideModal: FunctionComponent = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        className="unbutton link link-with-icon"
        onClick={() => setOpen(true)}
      >
        <img src={iconLink.src} alt="" /> View Size Guide here.
      </button>

      <Dialog
        className="fixed inset-0 bg-underlay bg-opacity-25 flex min-h-full items-center justify-center text-center z-10"
        open={open}
        onClose={() => setOpen(false)}
      >
        <Dialog.Panel className="max-h-screen color-standard f0 relative overflow-scroll">
          <button
            className={`unbutton ${styles.close}`}
            onClick={() => setOpen(false)}
          >
            <img src={iconClose.src} alt="Close style guide" />
          </button>

          <div className="stack-l gap-s1 m-s3">
            <div className="stack-l gap-s_1 text-left">
              <Dialog.Title className="text-f3 w-15/16">
                Tee Size Guide
              </Dialog.Title>
              <p className="text-f_1">
                Measure under your arms, around the fullest part of your chest.
              </p>
            </div>

            <div className="w-full overflow-scroll">
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>Size</th>
                    <th>Chest</th>
                  </tr>
                </thead>

                <tbody>
                  {adultSizes.map((size) => (
                    <tr key={size[0]}>
                      <th>{size[0]}</th>
                      <td>{size[1]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </>
  )
}
